import { IColumn } from '@features/General'

export const listUserColumns = (i18n): IColumn[] => [
    {
        title: i18n?.General?.Firstname,
        dataIndex: 'userId',
        key: 'firstname',
        type: 'nested',
        fields: ['firstname']
    },
    {
        title: i18n?.General?.Lastname,
        dataIndex: 'userId',
        key: 'lastname',
        type: 'nested',
        fields: ['lastname']
    },
    {
        title: i18n?.General?.Email,
        dataIndex: 'userId',
        key: 'email',
        type: 'nested',
        fields: ['email']
    }
]
